import React, { FC } from 'react';
import classnames from 'classnames';

import { useBufferedRanges } from '../../hooks/use-buffered-ranges';
import { useDuration } from '../../hooks/use-duration';

import styles from './styles.module.css';

interface Props {
    className?: string;
}

export const BufferedRangesBar: FC<Props> = ({ className }) => {
    const bufferedRanges = useBufferedRanges();
    const duration = useDuration();

    if (!bufferedRanges?.length) {
        return null;
    }

    return (
        <div className={classnames(styles.root, className)}>
            {bufferedRanges.map((bufferedRange) => (
                <div
                    key={bufferedRange.start.streamTime}
                    className={styles.bufferedRange}
                    style={{
                        left: `${duration.getPercentFromTime(bufferedRange.start) * 100}%`,
                        width: `${
                            (duration.getPercentFromTime(bufferedRange.end) -
                                duration.getPercentFromTime(bufferedRange.start)) *
                            100
                        }%`,
                    }}
                />
            ))}
        </div>
    );
};
